module.exports = __webpack_public_path__ + "img/Flip Card 1.00ccfbb9.svg";